import React, { useEffect, useState } from 'react';
import {
  Table,
  Drawer,
  Button,
  Form,
  Input,
  Select,
  InputNumber,
  Switch,
  Space,
  message,
} from 'antd';
import axios from 'axios';
import { getAllUsersApi, updateUserApi } from '../../services/users';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { render } from '@testing-library/react';

const { Option } = Select;

const ViewUser = () => {
  const [users, setUsers] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [form] = Form.useForm();
const {tenantId,companyId} = useParams()

  // Fetch users and dropdown data
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let params = {}
      if(tenantId) params={tenantId:tenantId}
      if(companyId) params={companyId:companyId}

      const [userRes] = await Promise.all([
        getAllUsersApi(params),
        // axios.get('/api/roles'),
        // axios.get('/api/tenants'),
        // axios.get('/api/companies'),
      ]);
      setUsers(userRes);
    //   setRoles(roleRes.data);
    //   setTenants(tenantRes.data);
    //   setCompanies(companyRes.data);
    } catch (err) {
      message.error('Failed to load data');
    }
  };

  const openDrawer = (user) => {
    setEditingUser(user);
    setDrawerOpen(true);
    form.setFieldsValue({
      ...user,
      role: user.role?._id,
    });
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setEditingUser(null);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      let res = await updateUserApi(editingUser._id,values)
      // await axios.put(`/api/user/${editingUser._id}`, values);
      if(res)
        toast.success('User updated');
      fetchData();
      closeDrawer();
    } catch (err) {
      message.error(err.response?.data?.error || 'Update failed');
    }
  };

  const columns = [
    { title: 'Name', dataIndex: 'name' },
    { title: 'Email', dataIndex: 'email' },
    { title: 'Mobile', dataIndex: 'mobile' },
    { title: 'Brand', dataIndex: 'brand',
      render:(d,record)=>{
        return (
          <p>{record?.company?.tenantDetails?.name||'-'}</p>
        )
      }

     },
    { title: 'Company', dataIndex: 'company',
      render:(d,record)=>{
        return (
          <p>{record?.company?.name||'-'}</p>
        )
      }

     },
    {
      title: 'Role',
      dataIndex: ['role', 'name'],
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      render: (val) => (val ? 'Yes' : 'No'),
    },
    {
      title: 'Action',
      render: (_, record) => (
        <Button type="link" onClick={() => openDrawer(record)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={users}
        pagination={{ pageSize: 8 }}
      />

      <Drawer
        title="Edit User"
        width={480}
        onClose={closeDrawer}
        open={drawerOpen}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          initialValues={{ isActive: true, onSalary: false }}
        >
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="email" label="Email" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="mobile" label="Mobile" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          {/* <Form.Item name="role" label="Role" rules={[{ required: true }]}>
            <Select placeholder="Select role">
              {roles.map((r) => (
                <Option key={r._id} value={r._id}>
                  {r.name}
                </Option>
              ))}
            </Select>
          </Form.Item> */}

         {/* {!tenantId&& <Form.Item name="tenant" label="Tenant">
            <Select placeholder="Select tenant">
              {tenants.map((t) => (
                <Option key={t._id} value={t._id}>
                  {t.tenantName}
                </Option>
              ))}
            </Select>
          </Form.Item>} */}

         {/* {!tenantId&& <Form.Item name="company" label="Company">
            <Select placeholder="Select company">
              {companies.map((c) => (
                <Option key={c._id} value={c._id}>
                  {c.name}
                </Option>
              ))}
            </Select>
          </Form.Item>} */}

          <Form.Item name="isActive" label="Is Active" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item name="onSalary" label="On Salary" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) =>
              getFieldValue('onSalary') ? (
                <Form.Item
                  name="salary"
                  label="Salary (₹)"
                  rules={[{ required: true }]}
                >
                  <InputNumber style={{ width: '100%' }} />
                </Form.Item>
              ) : null
            }
          </Form.Item>

          <Form.Item name={['bankDetails', 'accountNumber']} label="Account Number">
            <Input />
          </Form.Item>
          <Form.Item name={['bankDetails', 'ifscCode']} label="IFSC Code">
            <Input />
          </Form.Item>
          <Form.Item name={['bankDetails', 'bankName']} label="Bank Name">
            <Input />
          </Form.Item>
          <Form.Item name={['bankDetails', 'branch']} label="Branch">
            <Input />
          </Form.Item>
          <Form.Item name={['bankDetails', 'holderName']} label="Account Holder Name">
            <Input />
          </Form.Item>

          <Space style={{ marginTop: 16 }}>
            <Button type="primary" htmlType="submit">
              Update User
            </Button>
            <Button onClick={closeDrawer}>Cancel</Button>
          </Space>
        </Form>
      </Drawer>
    </>
  );
};

export default ViewUser;
